export default "__VITE_ASSET__BuI4ku1G__"